<template>
    <div class="new-trip-component container">
        <div class="alert alert-info alert-sellado-viaje" v-if="this.config.module_trip_creation_payment_enabled">
            <p>{{ $t('mensajeContandoSobreSelladoViaje') }}</p>
            <p>{{ $t('podesHacerViajesGratis', { freeTrips: free_trips_amount }) }}</p>
            <div v-if="trips_created_by_user_amount >= free_trips_amount">
                <p>{{ $t('yaCreasteViajes', { tripsCreated: trips_created_by_user_amount }) }}</p>
            </div>
            <div v-if="trips_created_by_user_amount < free_trips_amount">
                <p>{{ $t('teQuedaViajesGratis', { remaining: remainingFreeTrips }) }}</p>
            </div>
        </div>

        <div class="form form-trip">
            <div class="row">
                <div :class="columnClass[0]">
                    <h2
                        class="title--desktop"
                        v-if="tripCardTheme === 'light' && !isMobile"
                    >
                        {{ $t('crearViaje') }}
                    </h2>
                    <fieldset
                        class="trip-type-selection"
                        v-if="tripCardTheme !== 'light'"
                    >
                        <div class="radio-option">
                            <input
                                type="radio"
                                id="type-driver"
                                value="0"
                                v-model="trip.is_passenger"
                                :disabled="updatingTrip"
                            />
                            <label for="type-driver" class="control-label">
                                {{ $t('comoConductor') }}
                            </label>
                        </div>
                        <div class="radio-option">
                            <input
                                type="radio"
                                id="type-passenger"
                                value="1"
                                v-model="trip.is_passenger"
                                :disabled="updatingTrip"
                            />
                            <label for="type-passenger" class="control-label">
                                {{ $t('comoPasajero') }}
                            </label>
                        </div>
                    </fieldset>
                    <fieldset
                        class="trip-type-selection--light"
                        v-if="tripCardTheme === 'light'"
                    >
                        <div class="row">
                            <div class="col-xs-12 col-md-12 col-lg-12">
                                <button
                                    class="btn btn-option"
                                    @click="setIsPassenger(0)"
                                    :disabled="updatingTrip"
                                    :class="
                                        trip.is_passenger == 0 ? 'active' : ''
                                    "
                                    v-html="$t('buscoConductor')"
                                >
                                </button>
                            </div>
                            <div class="col-xs-12 col-md-12 col-lg-12">
                                <button
                                    class="btn btn-option"
                                    @click="setIsPassenger(1)"
                                    :disabled="updatingTrip"
                                    :class="
                                        trip.is_passenger == 1 ? 'active' : ''
                                    "
                                >
                                    {{ $t('buscoPasajero') }}
                                </button>
                            </div>
                        </div>
                    </fieldset>
                    <div
                        class="new-left trip_points trip_points--left"
                        v-if="!isMobile && tripCardTheme === 'light'"
                    >
                        <div
                            v-for="(m, index) in points"
                            class="trip_point gmap-autocomplete"
                            :class="{ 'trip-error': m.error.state }"
                            :key="m.id"
                        >
                            <span v-if="index == 0" class="sr-only">{{
                                $t('origen')
                            }}</span>
                            <span
                                v-if="index == points.length - 1"
                                class="sr-only"
                            >
                                {{ $t('destino') }}
                            </span>
                            <autocomplete
                                :placeholder="getPlaceholder(index)"
                                name="'input-' + index"
                                ref="'input-' + index"
                                :value="m.name"
                                v-on:place_changed="
                                    (data) => getPlace(index, data)
                                "
                                :classes="'form-control form-control-with-icon form-control-map-autocomplete'"
                                :country="config && config.osm_country"
                                :class="{ 'has-error': m.error.state }"
                            ></autocomplete>
                            <!-- <GmapAutocomplete  :selectFirstOnEnter="true" :types="['(cities)']" :componentRestrictions="allowForeignPoints ? null : {country: 'AR'}" :placeholder="getPlaceholder(index)"  :value="m.name" :name="'input-' + index" :ref="'input-' + index" v-on:place_changed="(data) => getPlace(index, data)" class="form-control form-control-with-icon form-control-map-autocomplete" :class="{'has-error': m.error.state}"> </GmapAutocomplete> -->
                            <div
                                @click="resetPoints(m, index)"
                                class="date-picker--cross"
                            >
                                <i aria-hidden="true" class="fa fa-times"></i>
                            </div>
                            <span class="error" v-if="m.error.state">
                                {{ m.error.message }}
                            </span>
                        </div>
                    </div>
                    <div class="trip_terms" v-if="trip.is_passenger == 0">
                        <input
                            type="checkbox"
                            id="no-lucrar"
                            v-model="no_lucrar"
                            class="checkbox-button"
                        />
                        <label
                            for="no-lucrar"
                            class="trip_terms_label checkbox-click-target"
                            :class="{ 'has-error': lucrarError.state }"
                        >
                            <span class="checkbox-box"></span>
                            <span>
                                {{ $t('meComprometo') }}
                                <span
                                    class="tooltip-bottom"
                                    :data-tooltip="$t('contribucionMaximaPista')"
                                >
                                    <i
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                                <br />
                                <small>{{ $t('contribucionMaxima') }}</small>
                            </span>
                        </label>
                    </div>
                    <!-- <pre style="background: #f5f5f5; padding: 10px; margin: 10px; border-radius: 4px; font-size: 12px;">
{{ JSON.stringify({
    ...this
}, null, 2) }}</pre> -->
                </div>
                <div :class="columnClass[1]">
                    <div class="row">
                        <div class="panel-trip-data">
                            <div
                                class="col-md-24"
                                v-show="isMobile && !tripCardTheme === 'light'"
                            >
                                <hr />
                            </div>
                            <div
                                class="new-left trip_points col-sm-13 col-md-15"
                                v-if="isMobile || tripCardTheme !== 'light'"
                            >
                                <div
                                    v-for="(m, index) in points"
                                    class="trip_point gmap-autocomplete"
                                    :class="{ 'trip-error': m.error.state }"
                                    :key="m.id"
                                >
                                    <span v-if="index == 0" class="sr-only">
                                        {{ $t('origen') }}
                                    </span>
                                    <span
                                        v-if="index == points.length - 1"
                                        class="sr-only"
                                    >
                                        {{ $t('destino') }}
                                    </span>
                                    <autocomplete
                                        :placeholder="getPlaceholder(index)"
                                        name="'input-' + index"
                                        ref="'input-' + index"
                                        :value="m.name"
                                        v-on:place_changed="
                                            (data) => getPlace(index, data)
                                        "
                                        :classes="'form-control form-control-with-icon form-control-map-autocomplete'"
                                        :country="config && config.osm_country"
                                        :class="{ 'has-error': m.error.state }"
                                    ></autocomplete>
                                    <!-- <GmapAutocomplete  :selectFirstOnEnter="true" :types="['(cities)']" :componentRestrictions="allowForeignPoints ? null : {country: 'AR'}" :placeholder="getPlaceholder(index)"  :value="m.name" :name="'input-' + index" :ref="'input-' + index" v-on:place_changed="(data) => getPlace(index, data)" class="form-control form-control-with-icon form-control-map-autocomplete" :class="{'has-error': m.error.state}"> </GmapAutocomplete> -->
                                    <div
                                        @click="resetPoints(m, index)"
                                        class="date-picker--cross"
                                    >
                                        <i
                                            aria-hidden="true"
                                            class="fa fa-times"
                                        ></i>
                                    </div>
                                    <span class="error" v-if="m.error.state">
                                        {{ m.error.message }}
                                    </span>
                                </div>
                            </div>
                            <div
                                v-if="tripCardTheme !== 'light' || isMobile"
                                class="col-sm-11 col-md-9"
                            >
                                <div class="trip_information">
                                    <ul class="no-bullet">
                                        <li class="list_item">
                                            <i
                                                class="fa fa-link"
                                                aria-hidden="true"
                                                v-if="tripCardTheme === 'light'"
                                            ></i>
                                            <div
                                                class="label-soft"
                                                v-if="tripCardTheme !== 'light'"
                                            >
                                                {{ $t('distanciaARecorrer') }}
                                            </div>
                                            <div>{{ distanceString }}</div>
                                        </li>
                                        <li class="list_item">
                                            <i
                                                class="fa fa-clock-o"
                                                aria-hidden="true"
                                                v-if="tripCardTheme === 'light'"
                                            ></i>
                                            <div
                                                class="label-soft"
                                                v-if="tripCardTheme !== 'light'"
                                            >
                                                {{ $t('tiempoEstimado') }}
                                            </div>
                                            <div>{{ estimatedTimeString }}</div>
                                        </li>
                                        <li class="list_item">
                                            <i
                                                class="fa fa-leaf"
                                                aria-hidden="true"
                                                v-if="tripCardTheme === 'light'"
                                            ></i>
                                            <div
                                                class="label-soft"
                                                v-if="tripCardTheme !== 'light'"
                                            >
                                                {{ $t('huellaCarbono') }} (
                                                <abbr :title="$t('kilogramosDioxidoCarbono')">
                                                    kg CO<sub>2</sub> eq.
                                                </abbr>
                                                )
                                            </div>
                                            <div>{{ CO2String }}</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="new-left col-sm-13 col-md-15">
                            <div class="trip_schedule-toggle" v-if="config.weekly_schedule">
                                <div class="schedule-toggle-buttons">
                                    <button type="button" class="btn btn-option schedule-tab" @click="useWeeklySchedule = false" :class="!useWeeklySchedule ? 'active' : ''">
                                        {{ $t('unaVez') }}
                                    </button>
                                    <button type="button" class="btn btn-option schedule-tab" @click="useWeeklySchedule = true" :class="useWeeklySchedule ? 'active' : ''">
                                        {{ $t('programaSemanal') }}
                                    </button>
                                </div>
                            </div>
                            <div class="trip_datetime" v-if="!useWeeklySchedule">
                                <div class="trip_date">
                                    <label for="date" class="sr-only">{{
                                        $t('dia')
                                    }}</label>
                                    <DatePicker
                                        :value="date"
                                        :minDate="minDate"
                                        :class="{
                                            'has-error': dateError.state
                                        }"
                                        v-on:date_changed="changeDate"
                                    ></DatePicker>
                                    <span class="error" v-if="dateError.state">
                                        {{ dateError.message }}
                                    </span>
                                </div>
                                <div class="trip_time">
                                    <label for="time" class="sr-only">{{
                                        $t('hora')
                                    }}</label>
                                    <input
                                        type="time"
                                        v-mask="'##:##'"
                                        v-model="time"
                                        class="form-control form-control-with-icon form-control-time"
                                        id="time"
                                        :class="{
                                            'has-error': timeError.state
                                        }"
                                        placeholder="Hora (12:00)"
                                    />
                                    <span class="error" v-if="timeError.state">
                                        {{ timeError.message }}
                                    </span>
                                    <!--<input type="text" v-model="time" />-->
                                </div>
                            </div>
                            <div class="trip-weekly-schedule" v-if="useWeeklySchedule && config.weekly_schedule">
                                <WeeklySchedule
                                    :weeklySchedule.sync="weeklySchedule"
                                    :weeklyScheduleTime.sync="weeklyScheduleTime"
                                    :readonly="false"
                                    :theme="tripCardTheme"
                                    :hasError="timeError.state"
                                />
                                <span class="error" v-if="timeError.state">
                                    {{ timeError.message }}
                                </span>
                            </div>
                            <div class="trip_seats-available">
                                <fieldset>
                                    <span class="label-for-group">
                                        <svg-item
                                            v-if="tripCardTheme === 'light'"
                                            :size="28"
                                            :icon="'icono-sentado'"
                                        ></svg-item>
                                        {{
                                            trip.is_passenger == 0
                                                ? $t('lugaresDisponibles')
                                                : $t('cuposNecesarios')
                                        }}
                                    </span>
                                    <span v-if="tripCardTheme !== 'light'">
                                        <span class="radio-inline">
                                            <input
                                                type="radio"
                                                id="seats-one"
                                                :value="1"
                                                v-model.number="trip.total_seats"
                                            />
                                            <label for="seats-one">1</label>
                                        </span>
                                        <span class="radio-inline">
                                            <input
                                                type="radio"
                                                id="seats-two"
                                                :value="2"
                                                v-model.number="trip.total_seats"
                                            />
                                            <label for="seats-two">2</label>
                                        </span>
                                        <span class="radio-inline">
                                            <input
                                                type="radio"
                                                id="seats-three"
                                                :value="3"
                                                v-model.number="trip.total_seats"
                                            />
                                            <label for="seats-three">3</label>
                                        </span>
                                        <span class="radio-inline">
                                            <input
                                                type="radio"
                                                id="seats-four"
                                                :value="4"
                                                v-model.number="trip.total_seats"
                                            />
                                            <label for="seats-four">4</label>
                                        </span>
                                    </span>
                                    <span
                                        class="seats-widget"
                                        v-if="tripCardTheme === 'light'"
                                    >
                                        <button
                                            type="button"
                                            @click="
                                                () =>
                                                    trip.total_seats < 4
                                                        ? trip.total_seats++
                                                        : trip.total_seats
                                            "
                                            class="btn btn-link"
                                            :disabled="trip.total_seats === 4"
                                        >
                                            <svg-item
                                                :size="28"
                                                :icon="'add'"
                                            ></svg-item>
                                        </button>
                                        <span class="total_seats">{{
                                            trip.total_seats
                                        }}</span>
                                        <button
                                            type="button"
                                            @click="
                                                () =>
                                                    trip.total_seats > 1
                                                        ? trip.total_seats--
                                                        : trip.total_seats
                                            "
                                            class="btn btn-link"
                                            :disabled="trip.total_seats === 1"
                                        >
                                            <svg-item
                                                :size="28"
                                                :icon="'remove'"
                                            ></svg-item>
                                        </button>
                                    </span>
                                </fieldset>
                                <span class="error" v-if="seatsError.state">
                                    {{ seatsError.message }}
                                </span>
                            </div>
                            <div
                                class="trip_price"
                                v-if="trip.is_passenger == 0 && !config.module_max_price_enabled && config.module_seat_price_enabled"
                            >
                                <legend class="label-for-group label-tooltip">
                                    {{ $t('precioAsiento') }}
                                <span
                                    class="tooltip-bottom tooltip-seat-price"
                                    :data-tooltip="$t('precioAsientoTooltip', { sellado: this.config.module_trip_creation_payment_enabled ? ' y Sellado de Viaje.' : '' })"
                                >
                                    <i
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                                </legend>

                                <input
                                    type="number"
                                    v-model="price"
                                    class="form-control form-control-with-icon form-control-price"
                                    id="price"
                                    :class="{ 'has-error': priceError.state }"
                                    :placeholder="price"
                                />
                                <span class="error" v-if="priceError.state">
                                    {{ priceError.message }}
                                </span>
                            </div>

                            <div
                                class="list_item"
                                v-if="
                                    trip.is_passenger == 0 &&
                                    config.module_max_price_enabled
                                "
                            >
                                <i
                                    class="fa fa-link"
                                    aria-hidden="true"
                                    v-if="tripCardTheme === 'light'"
                                ></i>
                            </div>
                            <div
                                class="trip_price"
                                v-if="
                                    trip.is_passenger == 0 &&
                                    config.module_max_price_enabled &&
                                    config.module_seat_price_enabled
                                "
                            >
                                <legend class="label-for-group label-tooltip">
                                    {{ $t('precioAsiento') }}
                                    <span
                                        class="tooltip-bottom tooltip-seat-price"
                                        :data-tooltip="$t('precioAsientoTooltip', { sellado: this.config.module_trip_creation_payment_enabled ? ' y Sellado de Viaje.' : '' })"
                                    >
                                        <i
                                            class="fa fa-info-circle"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </legend>

                                <input
                                    type="number"
                                    v-model="price"
                                    class="form-control form-control-with-icon form-control-price"
                                    id="price"
                                    :class="{ 'has-error': priceError.state }"
                                    :placeholder="price"
                                    :max="maximum_seat_price_cents / 100"
                                    @input="validatePrice"
                                />
                                <span class="error" v-if="priceError.state">
                                    {{ priceError.message }}
                                </span>
                            </div>

                            <div v-if="trip.is_passenger == 0 && this.trip.distance > 0 && config.module_seat_price_enabled">
                                <div
                                class="label-soft"
                                v-if="tripCardTheme !== 'light'"
                                style="
                                    color: var(--trip-mostly-free-color);
                                    font-weight: bold;
                                    margin-bottom: 10px;
                                    font-size: 1.1rem;
                                "
                                >
                                    {{ $t('contribucionRecomendadaLabel') }}

                                    <span
                                        style="
                                            color: var(
                                                --trip-almost-fill-color
                                            );
                                        "
                                    >
                                        $ {{ recommendedSeatPrice }}

                                    <span>

                                        <span
                                            class="tooltip-seat-price"
                                            :data-tooltip="$t('calculadoEnBaseNaftaTooltip')"
                                        >
                                            <i
                                                class="fa fa-info-circle"
                                                aria-hidden="true"
                                            ></i>
                                        </span>
                                    </span>
                                    </span>
                                </div>
                            </div>

                            <div class="trip-comment">
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                                    <label
                                        for="trip_comment"
                                        class="label-for-group"
                                        style="margin-bottom: 0;"
                                    >
                                        {{
                                            trip.is_passenger == 0
                                                ? $t('comentarioPasajeros')
                                                : $t('comentario')
                                        }}
                                    </label>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-primary"
                                        @click="generateAIDescription"
                                        style="display: flex; align-items: center; gap: 6px; font-size: 13px; padding: 4px 12px;"
                                    >
                                        <i class="fa fa-magic" aria-hidden="true"></i>
                                        {{ $t('generarConIA') }}
                                    </button>
                                </div>
                                <textarea
                                    maxlength="2000"
                                    v-model="trip.description"
                                    id="trp_comment"
                                    class="form-control"
                                    :placeholder="
                                        $t('placeholderComentarioPasajeros')
                                    "
                                ></textarea>
                                <span class="error" v-if="commentError.state">
                                    {{ commentError.message }}
                                </span>
                            </div>
                        </div>
                        <div class="col-sm-11 col-md-9 preferences-container">
                            <!-- <fieldset class="trip-privacity">
                                <legend class="label-for-group">
                                    {{ $t('privacidadViaje') }}
                                </legend>
                                <ul class="no-bullet">
                                    <li>
                                        <input
                                            type="radio"
                                            id="privacity-public"
                                            value="2"
                                            v-model="trip.friendship_type_id"
                                        />
                                        <label
                                            for="privacity-public"
                                            class="label-soft"
                                        >
                                            {{ $t('publico') }}
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            type="radio"
                                            id="privacity-friendofriend"
                                            value="1"
                                            v-model="trip.friendship_type_id"
                                        />
                                        <label
                                            for="privacity-friendofriend"
                                            class="label-soft"
                                        >
                                            {{ $t('amigosamigos') }}
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            type="radio"
                                            id="privacity-friend"
                                            value="0"
                                            v-model="trip.friendship_type_id"
                                        />
                                        <label
                                            for="privacity-friend"
                                            class="label-soft"
                                        >
                                            {{ $t('soloAmigos') }}
                                        </label>
                                    </li>
                                </ul>
                            </fieldset> -->
                            <legend class="label-for-group">
                                {{ $t('preferenciasViaje') }}
                            </legend>
                            <br />
                            <div
                                class="preferences row"
                                v-if="tripCardTheme !== 'light' || isMobile"
                            >
                                <div class="col-xs-8">
                                    <div class="col-xs-12">
                                        <input
                                            type="checkbox"
                                            id="smoking"
                                            v-model="trip.allow_smoking"
                                        />
                                    </div>
                                    <div class="col-xs-12">
                                        <SvgItem
                                            icon="no-smoking"
                                            :size="24"
                                        ></SvgItem>
                                    </div>
                                    <div class="col-xs-24">
                                        <label
                                            for="allow-smoking"
                                            class="label-soft preferences-text"
                                        >
                                            {{ $t('nofumar') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xs-8">
                                    <div class="col-xs-12">
                                        <input
                                            type="checkbox"
                                            id="animals"
                                            v-model="trip.allow_animals"
                                        />
                                    </div>
                                    <div class="col-xs-12">
                                        <SvgItem
                                            icon="no-animals"
                                            :size="24"
                                        ></SvgItem>
                                    </div>
                                    <div class="col-xs-24 no-padding">
                                        <label
                                            for="allow-animals"
                                            class="label-soft preferences-text"
                                        >
                                            {{ $t('noanimales') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xs-8">
                                    <div class="col-xs-12">
                                        <input
                                            type="checkbox"
                                            id="kids"
                                            v-model="trip.allow_kids"
                                        />
                                    </div>
                                    <div class="col-xs-12">
                                        <SvgItem
                                            icon="no-kids"
                                            :size="24"
                                        ></SvgItem>
                                    </div>
                                    <div class="col-xs-24 no-padding">
                                        <label
                                            for="allow-kids"
                                            class="label-soft preferences-text"
                                        >
                                            {{ $t('noninos') }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <ul
                                class="no-bullet preferences row"
                                v-if="tripCardTheme === 'light' && !isMobile"
                            >
                                <li>
                                    <input
                                        type="checkbox"
                                        id="smoking"
                                        v-model="trip.allow_smoking"
                                        class="checkbox-button"
                                    />
                                    <label
                                        for="smoking"
                                        class="label-soft preferences-text checkbox-click-target"
                                    >
                                        <span class="checkbox-box"></span>
                                        <SvgItem
                                            icon="no-smoking"
                                            :size="24"
                                        ></SvgItem>
                                        {{ $t('nofumar') }}
                                    </label>
                                </li>
                                <li>
                                    <input
                                        type="checkbox"
                                        id="animals"
                                        v-model="trip.allow_animals"
                                        class="checkbox-button"
                                    />
                                    <label
                                        for="animals"
                                        class="label-soft preferences-text checkbox-click-target"
                                    >
                                        <span class="checkbox-box"></span>
                                        <SvgItem
                                            icon="no-animals"
                                            :size="24"
                                        ></SvgItem>
                                        {{ $t('noanimales') }}
                                    </label>
                                </li>
                                <li>
                                    <input
                                        type="checkbox"
                                        id="kids"
                                        v-model="trip.allow_kids"
                                        class="checkbox-button"
                                    />
                                    <label
                                        for="allow-kids"
                                        class="label-soft preferences-text checkbox-click-target"
                                    >
                                        <span class="checkbox-box"></span>
                                        <SvgItem
                                            icon="kids"
                                            :size="24"
                                        ></SvgItem>
                                        {{ $t('noninos') }}
                                    </label>
                                </li>
                            </ul>
                            <div v-if="!updatingTrip" class="row row-showReturnTrip">
                                <hr class="col-md-20" />
                                <div class="checkbox-trip-return col-md-24">
                                    <span>
                                        <input
                                            type="checkbox"
                                            v-model="showReturnTrip"
                                            id="cbxShowReturnTrip"
                                        />
                                        <label for="cbxShowReturnTrip">
                                            {{ $t('cargarViajeRegreso') }}
                                        </label>
                                    </span>
                                </div>
                            </div>
                            <button
                                v-if="!showReturnTrip"
                                class="trip-create btn btn-primary btn-lg"
                                :class="{ 'trip-create--update': updatingTrip && !showReturnTrip }"
                                @click="save"
                                :disabled="saving"
                            >
                                <span v-if="!updatingTrip">
                                    <spinner
                                        class="blue"
                                        v-if="saving"
                                    ></spinner>
                                    <span v-else>{{ $t('crear') }}</span>
                                </span>
                                <span v-else>
                                    <spinner
                                        class="blue"
                                        v-if="saving"
                                    ></spinner>
                                    <span v-else>{{ $t('actualizar') }}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="tripCardTheme === 'light' && !isMobile"
                class="trip_information trip_information--light"
            >
                <ul class="no-bullet">
                    <li class="list_item">
                        <i
                            class="fa fa-link"
                            aria-hidden="true"
                            v-if="tripCardTheme === 'light'"
                        ></i>
                        <div class="label-soft">
                            {{ $t('distanciaARecorrer') }}
                        </div>
                        <div>{{ distanceString }}</div>
                    </li>
                    <li class="list_item">
                        <i
                            class="fa fa-clock-o"
                            aria-hidden="true"
                            v-if="tripCardTheme === 'light'"
                        ></i>
                        <div class="label-soft">{{ $t('tiempoEstimado') }}</div>
                        <div>{{ estimatedTimeString }}</div>
                    </li>
                    <li class="list_item">
                        <i
                            class="fa fa-leaf"
                            aria-hidden="true"
                            v-if="tripCardTheme === 'light'"
                        ></i>
                        <div class="label-soft">
                            {{ $t('huellaCarbono') }} (
                            <abbr
                                :title="$t('kilogramosDioxidoDeCarbonoEquivalente')"
                            >
                                kg CO
                                <sub>2eq</sub>
                            </abbr>
                            )
                        </div>
                        <div>{{ CO2String }}</div>
                    </li>
                </ul>
            </div>
            <div
                v-if="showReturnTrip"
                class="row show-return-trip"
            >
                <hr class="col-xs-24 hidden-sm hidden-md hidden-lg" />
                <div v-if="showReturnTrip" :class="columnClass[0]">
                    <div
                        class="new-left trip_points trip_points--left"
                        v-if="!isMobile && tripCardTheme === 'light'"
                    >
                        <div
                            v-for="(m, index) in otherTrip.points"
                            class="trip_point gmap-autocomplete"
                            :class="{ 'trip-error': m.error.state }"
                            :key="m.id"
                        >
                            <span v-if="index == 0" class="sr-only">{{
                                $t('origen')
                            }}</span>
                            <span
                                v-if="index == otherTrip.points.length - 1"
                                class="sr-only"
                            >
                                {{ $t('destino') }}
                            </span>
                            <autocomplete
                                :placeholder="getPlaceholder(index)"
                                name="'input-return-trip' + index"
                                ref="'input-return-trip' + index"
                                :value="m.name"
                                v-on:place_changed="
                                    (data) =>
                                        getPlace(
                                            index,
                                            data,
                                            'returnTrip'
                                        )
                                "
                                :classes="'form-control form-control-with-icon form-control-map-autocomplete'"
                                :country="config && config.osm_country"
                                :class="{ 'has-error': m.error.state }"
                            ></autocomplete>
                            <div
                                @click="resetReturnPoints(m, index)"
                                class="date-picker--cross"
                            >
                                <i
                                    aria-hidden="true"
                                    class="fa fa-times"
                                ></i>
                            </div>
                            <span class="error" v-if="m.error.state">
                                {{ m.error.message }}
                            </span>
                        </div>
                    </div>
                </div>
                <div v-if="showReturnTrip" :class="columnClass[1]">
                    <div class="row">
                        <div class="panel-other-trip-data">
                            <div
                                class="new-left trip_points col-sm-13 col-md-15"
                                v-if="isMobile || tripCardTheme !== 'light'"
                            >
                                <div
                                    v-for="(m, index) in otherTrip.points"
                                    class="trip_point gmap-autocomplete"
                                    :class="{ 'trip-error': m.error.state }"
                                    :key="m.id"
                                >
                                    <span v-if="index == 0" class="sr-only">
                                        {{ $t('origen') }}
                                    </span>
                                    <span
                                        v-if="index == otherTrip.points.length - 1"
                                        class="sr-only"
                                    >
                                        {{ $t('destino') }}
                                    </span>
                                    <autocomplete
                                        :placeholder="getPlaceholder(index)"
                                        name="'input-return-trip' + index"
                                        ref="'input-return-trip' + index"
                                        :value="m.name"
                                        v-on:place_changed="
                                            (data) =>
                                                getPlace(
                                                    index,
                                                    data,
                                                    'returnTrip'
                                                )
                                        "
                                        :classes="'form-control form-control-with-icon form-control-map-autocomplete'"
                                        :country="config && config.osm_country"
                                        :class="{ 'has-error': m.error.state }"
                                    ></autocomplete>
                                    <div
                                        @click="resetReturnPoints(m, index)"
                                        class="date-picker--cross"
                                    >
                                        <i
                                            aria-hidden="true"
                                            class="fa fa-times"
                                        ></i>
                                    </div>
                                    <span class="error" v-if="m.error.state">
                                        {{ m.error.message }}
                                    </span>
                                </div>
                            </div>
                            <div
                                v-if="tripCardTheme !== 'light' || isMobile"
                                class="col-sm-11 col-md-9"
                            >
                                <div class="trip_information">
                                    <ul class="no-bullet">
                                        <li class="list_item">
                                            <i
                                                class="fa fa-link"
                                                aria-hidden="true"
                                                v-if="tripCardTheme === 'light'"
                                            ></i>
                                            <div
                                                class="label-soft"
                                                v-if="tripCardTheme !== 'light'"
                                            >
                                                {{ $t('distanciaARecorrer') }}
                                            </div>
                                            <div>
                                                {{ otherTripDistanceString }}
                                            </div>
                                        </li>
                                        <li class="list_item">
                                            <i
                                                class="fa fa-clock-o"
                                                aria-hidden="true"
                                                v-if="tripCardTheme === 'light'"
                                            ></i>
                                            <div
                                                class="label-soft"
                                                v-if="tripCardTheme !== 'light'"
                                            >
                                                {{ $t('tiempoEstimado') }}
                                            </div>
                                            <div>
                                                {{
                                                    otherTripEstimatedTimeString
                                                }}
                                            </div>
                                        </li>
                                        <li class="list_item">
                                            <i
                                                class="fa fa-leaf"
                                                aria-hidden="true"
                                                v-if="tripCardTheme === 'light'"
                                            ></i>
                                            <div
                                                class="label-soft"
                                                v-if="tripCardTheme !== 'light'"
                                            >
                                                {{ $t('huellaCarbono') }} (
                                                    <abbr
                                                        :title="$t('kilogramosDioxidoDeCarbonoEquivalente')"
                                                    >
                                                    kg CO
                                                    <sub>2eq</sub>
                                                </abbr>
                                                )
                                            </div>
                                            <div>{{ otherTripCO2String }}</div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="new-left col-sm-13 col-md-15">
                            <div class="trip_schedule-toggle" v-if="config.weekly_schedule">
                                <div class="schedule-toggle-buttons">
                                    <button type="button" class="btn btn-option schedule-tab" @click="useWeeklySchedule = false" :class="!useWeeklySchedule ? 'active' : ''">
                                        {{ $t('unaVez') }}
                                    </button>
                                    <button type="button" class="btn btn-option schedule-tab" @click="useWeeklySchedule = true" :class="useWeeklySchedule ? 'active' : ''">
                                        {{ $t('programaSemanal') }}
                                    </button>
                                </div>
                            </div>
                            <div class="trip_datetime" v-if="!useWeeklySchedule">
                                <div class="trip_date">
                                    <label for="date" class="sr-only">{{
                                        $t('dia')
                                    }}</label>
                                    <DatePicker
                                        :value="otherTrip.date"
                                        :minDate="otherTrip.minDate"
                                        :class="{
                                            'has-error':
                                                otherTrip.dateError.state
                                        }"
                                        v-on:date_changed="changeOtherTripDate"
                                    ></DatePicker>
                                    <span
                                        class="error"
                                        v-if="otherTrip.dateError.state"
                                    >
                                        {{ otherTrip.dateError.message }}
                                    </span>
                                </div>
                                <div class="trip_time">
                                    <label for="otherTrip-time" class="sr-only">
                                        {{ $t('hora') }}
                                    </label>
                                    <input
                                        type="time"
                                        v-mask="'##:##'"
                                        v-model="otherTrip.time"
                                        class="form-control form-control-with-icon form-control-time"
                                        id="otherTrip-time"
                                        :class="{
                                            'has-error':
                                                otherTrip.timeError.state
                                        }"
                                        placeholder="Hora (12:00)"
                                    />
                                    <span
                                        class="error"
                                        v-if="otherTrip.timeError.state"
                                    >
                                        {{ otherTrip.timeError.message }}
                                    </span>
                                    <!--<input type="text" v-model="time" />-->
                                </div>
                            </div>
                            <div class="trip-weekly-schedule" v-if="useWeeklySchedule && config.weekly_schedule">
                                <WeeklySchedule
                                    :weeklySchedule.sync="weeklySchedule"
                                    :weeklyScheduleTime.sync="weeklyScheduleReturnTime"
                                    :readonly="false"
                                    :theme="tripCardTheme"
                                    :hasError="otherTrip.timeError.state"
                                    :idPrefix="'return-ws'"
                                />
                                <span class="error" v-if="otherTrip.timeError.state">
                                    {{ otherTrip.timeError.message }}
                                </span>
                            </div>
                            <div
                                class="trip_price"
                                v-if="trip.is_passenger == 0 && 
                                !config.module_max_price_enabled && 
                                config.module_seat_price_enabled"
                            >
                                <legend class="label-for-group label-tooltip">
                                    {{ $t('precioAsiento') }}
                                <span
                                    class="tooltip-bottom tooltip-seat-price"
                                    :data-tooltip="$t('precioAsientoTooltip', { sellado: this.config.module_trip_creation_payment_enabled ? ' y Sellado de Viaje.' : '' })"
                                >
                                    <i
                                        class="fa fa-info-circle"
                                        aria-hidden="true"
                                    ></i>
                                </span>
                                </legend>

                                <input
                                    type="number"
                                    v-model="returnPrice"
                                    class="form-control form-control-with-icon form-control-price"
                                    id="return-price"
                                    :class="{ 'has-error': returnPriceError.state }"
                                    :placeholder="returnPrice"
                                />
                                <span class="error" v-if="returnPriceError.state">
                                    {{ returnPriceError.message }}
                                </span>
                            </div>
                            <div
                                class="trip_price"
                                v-if="this.config.module_trip_creation_payment_enabled && config.module_seat_price_enabled"
                            >
                                <legend class="label-for-group label-tooltip">
                                    {{ $t('precioAsiento') }}
                                    <span
                                        class="tooltip-bottom tooltip-seat-price"
                                        :data-tooltip="$t('precioAsientoTooltip', { sellado: this.config.module_trip_creation_payment_enabled ? ' y Sellado de Viaje.' : '' })"
                                    >
                                        <i
                                            class="fa fa-info-circle"
                                            aria-hidden="true"
                                        ></i>
                                    </span>
                                </legend>
                                <input
                                    type="number"
                                    v-model="returnPrice"
                                    class="form-control form-control-with-icon form-control-price"
                                    id="return-price"
                                    :class="{
                                        'has-error': returnPriceError.state
                                    }"
                                    :placeholder="price"
                                    :max="maximum_seat_price_cents / 100"
                                    @input="validatePrice"
                                />
                                <span
                                    class="error"
                                    v-if="returnPriceError.state"
                                >
                                    {{ returnPriceError.message }}
                                </span>
                            </div>

                            <div v-if="trip.is_passenger == 0 && this.trip.distance > 0 && config.module_seat_price_enabled">
                                <div
                                class="label-soft"
                                v-if="tripCardTheme !== 'light'"
                                style="
                                    color: var(--trip-mostly-free-color);
                                    font-weight: bold;
                                    margin-bottom: 10px;
                                    font-size: 1.1rem;
                                "
                                >
                                    {{ $t('contribucionRecomendadaLabel') }}

                                    <span
                                        style="
                                            color: var(
                                                --trip-almost-fill-color
                                            );
                                        "
                                    >
                                        $ {{ recommendedReturnSeatPrice }}

                                    <span>

                                        <span
                                            class="tooltip-seat-price"
                                            :data-tooltip="$t('calculadoEnBaseNaftaTooltip')"
                                        >
                                            <i
                                                class="fa fa-info-circle"
                                                aria-hidden="true"
                                            ></i>
                                        </span>
                                    </span>
                                    </span>
                                </div>
                            </div>

                            <div class="trip_seats-available">
                                <fieldset>
                                    <span class="label-for-group">
                                        <svg-item
                                            v-if="tripCardTheme === 'light'"
                                            :size="28"
                                            :icon="'icono-sentado'"
                                        ></svg-item>
                                        {{
                                            trip.is_passenger
                                                ? $t('cuposNecesarios')
                                                : $t('lugaresDisponibles')
                                        }}
                                    </span>
                                    <span v-if="tripCardTheme !== 'light'">
                                        <span class="radio-inline">
                                            <input
                                                type="radio"
                                                id="otherTrip-seats-one"
                                                :value="1"
                                                v-model.number="
                                                    otherTrip.trip.total_seats
                                                "
                                            />
                                            <label for="otherTrip-seats-one"
                                                >1</label
                                            >
                                        </span>
                                        <span class="radio-inline">
                                            <input
                                                type="radio"
                                                id="otherTrip-seats-two"
                                                :value="2"
                                                v-model.number="
                                                    otherTrip.trip.total_seats
                                                "
                                            />
                                            <label for="otherTrip-seats-two"
                                                >2</label
                                            >
                                        </span>
                                        <span class="radio-inline">
                                            <input
                                                type="radio"
                                                id="otherTrip-seats-three"
                                                :value="3"
                                                v-model.number="
                                                    otherTrip.trip.total_seats
                                                "
                                            />
                                            <label for="otherTrip-seats-three"
                                                >3</label
                                            >
                                        </span>
                                        <span class="radio-inline">
                                            <input
                                                type="radio"
                                                id="otherTrip-seats-four"
                                                :value="4"
                                                v-model.number="
                                                    otherTrip.trip.total_seats
                                                "
                                            />
                                            <label for="otherTrip-seats-four"
                                                >4</label
                                            >
                                        </span>
                                    </span>
                                    <span
                                        class="seats-widget"
                                        v-if="tripCardTheme === 'light'"
                                    >
                                        <button
                                            type="button"
                                            @click="
                                                () =>
                                                    otherTrip.trip.total_seats <
                                                    4
                                                        ? otherTrip.trip
                                                              .total_seats++
                                                        : otherTrip.trip
                                                              .total_seats
                                            "
                                            class="btn btn-link"
                                            :disabled="
                                                otherTrip.trip.total_seats === 4
                                            "
                                        >
                                            <svg-item
                                                :size="28"
                                                :icon="'add'"
                                            ></svg-item>
                                        </button>
                                        <span class="total_seats">
                                            {{ otherTrip.trip.total_seats }}
                                        </span>
                                        <button
                                            type="button"
                                            @click="
                                                () =>
                                                    otherTrip.trip.total_seats >
                                                    1
                                                        ? otherTrip.trip
                                                              .total_seats--
                                                        : otherTrip.trip
                                                              .total_seats
                                            "
                                            class="btn btn-link"
                                            :disabled="
                                                otherTrip.trip.total_seats === 1
                                            "
                                        >
                                            <svg-item
                                                :size="28"
                                                :icon="'remove'"
                                            ></svg-item>
                                        </button>
                                    </span>
                                </fieldset>
                                <span
                                    class="error"
                                    v-if="otherTrip.seatsError.state"
                                >
                                    {{ otherTrip.seatsError.message }}
                                </span>
                            </div>
                            <div class="trip-comment">
                                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                                    <label
                                        for="otherTrip-trip_comment"
                                        class="label-for-group"
                                        style="margin-bottom: 0;"
                                    >
                                        {{ $t('comentarioPasajeros') }}
                                    </label>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-primary"
                                        @click="generateAIDescriptionForReturn"
                                        style="display: flex; align-items: center; gap: 6px; font-size: 13px; padding: 4px 12px;"
                                    >
                                        <i class="fa fa-magic" aria-hidden="true"></i>
                                        {{ $t('generarConIA') }}
                                    </button>
                                </div>
                                <textarea
                                    maxlength="2000"
                                    v-model="otherTrip.trip.description"
                                    id="other_trp_comment"
                                    class="form-control"
                                    :placeholder="
                                        $t('placeholderComentarioPasajeros')
                                    "
                                ></textarea>
                                <span class="error" v-if="otherTrip.commentError.state">
                                    {{ otherTrip.commentError.message }}
                                </span>
                            </div>
                        </div>
                        <div class="col-sm-11 col-md-9 preferences-container">
                            <fieldset class="trip-privacity">
                                <legend class="label-for-group">
                                    {{ $t('privacidadViaje') }}
                                </legend>
                                <ul class="no-bullet">
                                    <li>
                                        <input
                                            type="radio"
                                            id="otherTrip-privacity-public"
                                            value="2"
                                            v-model="
                                                otherTrip.trip
                                                    .friendship_type_id
                                            "
                                        />
                                        <label
                                            for="otherTrip-privacity-public"
                                            class="label-soft"
                                        >
                                            {{ $t('publico') }}
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            type="radio"
                                            id="otherTrip-privacity-friendofriend"
                                            value="1"
                                            v-model="
                                                otherTrip.trip
                                                    .friendship_type_id
                                            "
                                        />
                                        <label
                                            for="otherTrip-privacity-friendofriend"
                                            class="label-soft"
                                        >
                                            {{ $t('amigosamigos') }}
                                        </label>
                                    </li>
                                    <li>
                                        <input
                                            type="radio"
                                            id="otherTrip-privacity-friend"
                                            value="0"
                                            v-model="
                                                otherTrip.trip
                                                    .friendship_type_id
                                            "
                                        />
                                        <label
                                            for="otherTrip-privacity-friend"
                                            class="label-soft"
                                        >
                                            {{ $t('soloAmigos') }}
                                        </label>
                                    </li>
                                </ul>
                            </fieldset>
                            <legend class="label-for-group">
                                {{ $t('preferenciasViaje') }}
                            </legend>
                            <br />
                            <div
                                class="preferences row"
                                v-if="tripCardTheme !== 'light' || isMobile"
                            >
                                <div class="col-xs-8">
                                    <div class="col-xs-12">
                                        <input
                                            type="checkbox"
                                            id="smoking"
                                            v-model="
                                                otherTrip.trip.allow_smoking
                                            "
                                        />
                                    </div>
                                    <div class="col-xs-12">
                                        <SvgItem
                                            icon="no-smoking"
                                            :size="24"
                                        ></SvgItem>
                                    </div>
                                    <div class="col-xs-24">
                                        <label
                                            for="allow-smoking"
                                            class="label-soft preferences-text"
                                        >
                                            {{ $t('nofumar') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xs-8">
                                    <div class="col-xs-12">
                                        <input
                                            type="checkbox"
                                            id="animals"
                                            v-model="
                                                otherTrip.trip.allow_animals
                                            "
                                        />
                                    </div>
                                    <div class="col-xs-12">
                                        <SvgItem
                                            icon="no-animals"
                                            :size="24"
                                        ></SvgItem>
                                    </div>
                                    <div class="col-xs-24 no-padding">
                                        <label
                                            for="allow-animals"
                                            class="label-soft preferences-text"
                                        >
                                            {{ $t('noanimales') }}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-xs-8">
                                    <div class="col-xs-12">
                                        <input
                                            type="checkbox"
                                            id="kids"
                                            v-model="otherTrip.trip.allow_kids"
                                        />
                                    </div>
                                    <div class="col-xs-12">
                                        <SvgItem
                                            icon="no-kids"
                                            :size="24"
                                        ></SvgItem>
                                    </div>
                                    <div class="col-xs-24 no-padding">
                                        <label
                                            for="allow-kids"
                                            class="label-soft preferences-text"
                                        >
                                            {{ $t('noninos') }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <ul
                                class="no-bullet preferences row"
                                v-if="tripCardTheme === 'light' && !isMobile"
                            >
                                <li>
                                    <input
                                        type="checkbox"
                                        id="smoking"
                                        v-model="otherTrip.trip.allow_smoking"
                                    />
                                    <SvgItem
                                        icon="no-smoking"
                                        :size="24"
                                    ></SvgItem>
                                    <label
                                        for="allow-smoking"
                                        class="label-soft preferences-text"
                                    >
                                        {{ $t('nofumar') }}
                                    </label>
                                </li>
                                <li>
                                    <input
                                        type="checkbox"
                                        id="animals"
                                        v-model="otherTrip.trip.allow_animals"
                                    />
                                    <SvgItem
                                        icon="no-animals"
                                        :size="24"
                                    ></SvgItem>
                                    <label
                                        for="allow-animals"
                                        class="label-soft preferences-text"
                                    >
                                        {{ $t('noanimales') }}
                                    </label>
                                </li>
                                <li>
                                    <input
                                        type="checkbox"
                                        id="kids"
                                        v-model="otherTrip.trip.allow_kids"
                                    />
                                    <SvgItem
                                        icon="no-kids"
                                        :size="24"
                                    ></SvgItem>
                                    <label
                                        for="allow-kids"
                                        class="label-soft preferences-text"
                                    >
                                        {{ $t('noninos') }}
                                    </label>
                                </li>
                            </ul>
                            <button
                                v-if="showReturnTrip"
                                class="trip-create btn btn-primary btn-lg"
                                @click="save"
                                :disabled="saving"
                            >
                                <span v-if="!updatingTrip">
                                    <spinner
                                        class="blue"
                                        v-if="saving"
                                    ></spinner>
                                    <span v-else>{{ $t('crear') }}</span>
                                </span>
                                <span v-else>
                                    <spinner
                                        class="blue"
                                        v-if="saving"
                                    ></spinner>
                                    <span v-else>{{ $t('actualizar') }}</span>
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="
                    !updatingTrip &&
                    showReturnTrip &&
                    tripCardTheme === 'light' &&
                    !isMobile
                "
                class="trip_information trip_information--light"
            >
                <ul class="no-bullet">
                    <li class="list_item">
                        <i
                            class="fa fa-link"
                            aria-hidden="true"
                            v-if="tripCardTheme === 'light'"
                        ></i>
                        <div class="label-soft">
                            {{ $t('distanciaARecorrer') }}
                        </div>
                        <div>{{ distanceString }}</div>
                    </li>
                    <li class="list_item">
                        <i
                            class="fa fa-clock-o"
                            aria-hidden="true"
                            v-if="tripCardTheme === 'light'"
                        ></i>
                        <div class="label-soft">{{ $t('tiempoEstimado') }}</div>
                        <div>{{ estimatedTimeString }}</div>
                    </li>
                    <li class="list_item">
                        <i
                            class="fa fa-leaf"
                            aria-hidden="true"
                            v-if="tripCardTheme === 'light'"
                        ></i>
                        <div class="label-soft">
                            {{ $t('huellaCarbono') }} (
                            <abbr
                                :title="$t('kilogramosDioxidoDeCarbonoEquivalente')"
                            >
                                kg CO
                                <sub>2eq</sub>
                            </abbr>
                            )
                        </div>
                        <div>{{ CO2String }}</div>
                    </li>
                </ul>
            </div>
            <div class="row">
                <div class="col-xs-24 map"></div>
            </div>
        </div>

        <footer class="footer-section">
            <div class="footer-container">
                <div class="footer-left">
                    <div class="footer-logo-section">
                        <img src="https://i.imgur.com/z198fac.png" alt="MyEcoCar Logo" class="footer-logo" />
                        <span class="footer-brand-name">MyEcoCar</span>
                    </div>
                    <div class="footer-social-links">
                        <a href="#" class="social-link" title="Facebook">
                            <i class="fa fa-facebook-f"></i>
                        </a>
                        <a href="#" class="social-link" title="Twitter">
                            <i class="fa fa-twitter"></i>
                        </a>
                        <a href="#" class="social-link" title="Instagram">
                            <i class="fa fa-instagram"></i>
                        </a>
                        <a href="#" class="social-link" title="LinkedIn">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-center">
                    <div class="footer-column">
                        <h4 class="footer-column-title">Infos</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'cgu' }">CGU</router-link></li>
                            <li><router-link :to="{ name: 'faq' }">FAQ</router-link></li>
                            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Decouvrir</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'about' }">Qui sommes-nous ?</router-link></li>
                            <li><router-link :to="{ name: 'conduct-charter' }">Charte de bonne conduite</router-link></li>
                            <li><router-link :to="{ name: 'map' }">Carte Interactive</router-link></li>
                        </ul>
                    </div>

                    <div class="footer-column">
                        <h4 class="footer-column-title">Plus</h4>
                        <ul class="footer-links">
                            <li><router-link :to="{ name: 'concept' }">Notre Concept</router-link></li>
                            <li><router-link :to="{ name: 'cookies' }">Utilisation des cookies</router-link></li>
                            <li><router-link :to="{ name: 'sitemap' }">Plan du site</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer-bottom">
                <p class="footer-copyright">
                    &copy; {{ new Date().getFullYear() }} MyEcoCar. Tous les droits reserves.
                </p>
            </div>
        </footer>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { appLocaleToRoutingLanguage } from '../../main';
// import { parseOsmStreet } from '../../services/maps.js';
import DatePicker from '../DatePicker';
import dialogs from '../../services/dialogs.js';
import spinner from '../Spinner.vue';
import dayjs from '../../dayjs';
import { last } from 'lodash';
import TripApi from '../../services/api/Trips';
import UserApi from '../../services/api/User';
import autocomplete from '../Autocomplete';
import SvgItem from '../SvgItem';
import WeeklySchedule from '../elements/WeeklySchedule';
import bus from '../../services/bus-event.js';

let tripApi = new TripApi();
let userApi = new UserApi();

class Error {
    constructor(state = false, message = '') {
        this.state = false;
        this.message = '';
    }
}

export default {
    name: 'new-trip',
    props: {
        id: {
            type: [String, Number],
            required: false
        }
    },
    components: {
        DatePicker,
        WeeklySchedule,
        SvgItem,
        autocomplete,
        spinner
    },
    data() {
        return {
            minDate: dayjs().toDate(),
            lucrarError: new Error(),
            dateError: new Error(),
            timeError: new Error(),
            priceError: new Error(),
            returnPriceError: new Error(),
            commentError: new Error(),
            seatsError: new Error(),
            no_lucrar: false,
            sameCity: false,
            points: [
                {
                    name: '',
                    place: null,
                    json: null,
                    location: null,
                    error: new Error(),
                    id: 0
                },
                {
                    name: '',
                    place: null,
                    json: null,
                    location: null,
                    error: new Error(),
                    id: 1
                }
            ],
            date: '',
            dateAnswer: this.date,
            time: '12:00',
            price: 0,
            needs_to_pay_for_next_trip: false,
            maximum_trip_price_cents: 0,
            recommended_trip_price_cents: 0,
            maximum_seat_price_cents: 0,
            recommended_seat_price_cents: 0,
            maximum_return_trip_price_cents: 0,
            recommended_return_trip_price_cents: 0,
            maximum_return_seat_price_cents: 0,
            recommended_return_seat_price_cents: 0,
            free_trips_amount: 0,
            trips_created_by_user_amount: 0,
            route_needs_payment: false,
            returnPrice: 0,
            duration: 0,
            passengers: 0,
            trip: {
                is_passenger: 0,
                from_town: '',
                to_town: '',
                trip_date: '',
                total_seats: 2,
                friendship_type_id: 2,
                estimated_time: '00 h : 00 min',
                distance: 0.0,
                co2: 0.0,
                description: '',
                allow_kids: true,
                allow_smoking: true,
                allow_animals: true,
                car_id: null,
                enc_path: '123',
                points: [] /* address json_address lat lng */
            },
            updatingTrip: null,
            saving: false,
            url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            showReturnTrip: false,
            otherTrip: {
                minDate: dayjs().toDate(),
                dateError: new Error(),
                timeError: new Error(),
                commentError: new Error(),
                seatsError: new Error(),
                no_lucrar: false,
                sameCity: false,
                points: [
                    {
                        name: '',
                        place: null,
                        json: null,
                        location: null,
                        error: new Error()
                    },
                    {
                        name: '',
                        place: null,
                        json: null,
                        location: null,
                        error: new Error()
                    }
                ],
                date: '',
                dateAnswer: this.date,
                time: '12:00',
                duration: 0,
                passengers: 0,
                trip: {
                    is_passenger: 0,
                    from_town: '',
                    to_town: '',
                    trip_date: '',
                    total_seats: 2,
                    friendship_type_id: 2,
                    estimated_time: '00 h : 00 min',
                    distance: 0.0,
                    co2: 0.0,
                    description: '',
                    car_id: null,
                    enc_path: '123',
                    allow_kids: true,
                    allow_smoking: true,
                    allow_animals: true,
                    seat_price_cents: 0,
                    points: [] /* address json_address lat lng */
                }
            },
            useWeeklySchedule: false,
            weeklySchedule: 0,
            weeklyScheduleTime: '12:00',
            weeklyScheduleReturnTime: '12:00',
        };
    },
    mounted() {
        let self = this;
        this.time = dayjs().add(1, 'hours').format('HH:00');
        this.otherTrip.time = dayjs().add(2, 'hours').format('HH:00');
        this.weeklyScheduleTime = dayjs().add(1, 'hours').format('HH:00');
        this.weeklyScheduleReturnTime = dayjs().add(2, 'hours').format('HH:00');
        bus.off('clear-click', this.onBackButton);
        bus.on('clear-click', this.onBackButton);

        // Vérifier si on doit activer l'onglet passager depuis les query params
        if (this.$route.query.passenger === '1') {
            this.setIsPassenger(1);
            console.log('📝 [NewTrip] Onglet passager activé depuis query parameter');
        }

        if (self.id) {
            self.loadTrip();
        }

        userApi.selladoViaje().then((result) => {
            // if user is over the free trips limit, show a message telling them they need to pay for the next trip
            this.needs_to_pay_for_next_trip = this.config.module_trip_creation_payment_enabled && result.data.user_over_free_limit;
            this.free_trips_amount = result.data.free_trips_amount;
            this.trips_created_by_user_amount = result.data.trips_created_by_user_amount;
        });
    },
    beforeDestroy() {},

    computed: {
        ...mapGetters({
            user: 'auth/user',
            cars: 'cars/cars',
            isMobile: 'device/isMobile',
            config: 'auth/appConfig',
            tripCardTheme: 'auth/tripCardTheme'
        }),
        columnClass() {
            return !this.isMobile && this.tripCardTheme === 'light'
                ? ['col-sm-10', 'col-sm-14']
                : ['col-sm-8', 'col-sm-16'];
        },
        distanceString() {
            return Math.floor(this.trip.distance / 1000) + ' Km';
        },
        recommendedSeatPrice() {
            return Math.floor((this.recommended_seat_price_cents / 100)) ;
        },

        recommendedReturnSeatPrice() {
            return Math.floor((this.recommended_return_seat_price_cents / 100)) ;
        },

        estimatedTimeString() {
            const totalMinutes = Math.floor(this.duration / 60);
            const minutes = Math.floor(totalMinutes % 60);
            const hour = Math.floor(totalMinutes / 60);
            return (
                (hour < 10 ? '0' : '') +
                hour +
                ' h : ' +
                (minutes < 10 ? '0' : '') +
                minutes +
                ' min'
            );
        },
        CO2String() {
            return (Math.floor(this.trip.distance / 1000) * 0.15).toFixed(1)  + ' Kg';
        },
        otherTripDistanceString() {
            return Math.floor(this.otherTrip.trip.distance / 1000) + ' Km';
        },
        otherTripEstimatedTimeString() {
            const totalMinutes = Math.floor(this.otherTrip.duration / 60);
            const minutes = Math.floor(totalMinutes % 60);
            const hour = Math.floor(totalMinutes / 60);
            return (
                (hour < 10 ? '0' : '') +
                hour +
                ' h : ' +
                (minutes < 10 ? '0' : '') +
                minutes +
                ' min'
            );
        },
        otherTripCO2String() {
            return (
                Math.floor(this.otherTrip.trip.distance / 1000) * 0.15 + ' Kg'
            );
        },
        tripCardTheme() {
            return this.config ? this.config.trip_card_design : '';
        },
        remainingFreeTrips() {
            return this.free_trips_amount - this.trips_created_by_user_amount;
        },
        center() {
            return this.config ? this.config.map_coordinates : [46.5, 2.5];
        },
        zoom() {
            return this.config ? this.config.map_zoom : 6;
        }
    },
    watch: {
        no_lucrar: function () {
            this.lucrarError.state = false;
        },
        'trip.total_seats': function(newValue) {
            if (this.trip.distance > 0) {
                // The maximum_trip_price_cents is constant based on distance
                // We just need to recalculate the per-seat prices
                this.recalculateRecommendedPrice();
            }
        },
        'otherTrip.trip.total_seats': function(newValue) {
            if (this.otherTrip.trip.distance > 0) {
                this.recalculateRecommendedReturnPrice();
            }
        },
        dateAnswer: function (value) {
            if (!this.showReturnTrip || !this.otherTrip.dateAnswer) {
                // const v = dayjs(value);
                // let date = '';
                /* if (v.isValid()) {
                    date = value;
                } */
                // this.otherTrip.date = date;
                // this.otherTrip.dateAnswer = date;
            }
            // this.dateError.state = false;
        },
        time: function () {
            this.timeError.state = false;
        },
        weeklyScheduleTime: function () {
            this.timeError.state = false;
        },
        weeklyScheduleReturnTime: function () {
            this.otherTrip.timeError.state = false;
        },
        'otherTrip.dateAnswer': function () {
            this.otherTrip.dateError.state = false;
        },
        'otherTrip.time': function () {
            this.otherTrip.timeError.state = false;
        },
        'otherTrip.trip.description': function () {
            this.otherTrip.commentError.state = false;
        },
        'trip.friendship_type_id': function () {
            this.otherTrip.trip.friendship_type_id =
                this.trip.friendship_type_id;
        },
        // 'trip.distance': function () {
        //     // TODO: FIX THIS
        //     if (this.config.module_trip_creation_payment_enabled) {
        //         let data = {
        //             from: this.points[0].place,
        //             to: last(this.points).place,
        //             distance: this.trip.distance
        //         };
        //         this.getPrice(data).then((price) => {
        //             this.price = price;
        //             console.log(this.price);
        //         });
        //     }
        // },
        // 'otherTrip.distance': function () {
        //     let data = {
        //         from: this.otherTrip.points[0].place,
        //         to: last(this.otherTrip.points).place,
        //         distance: this.otherTrip.distance
        //     };
        //     this.getPrice(data).then((price) => {
        //         this.returnPrice = price;
        //         console.log(this.returnPrice);
        //     });
        // }
    },
    methods: {
        ...mapActions({
            createTrip: 'trips/create',
            updateTrip: 'trips/update',
            getTrip: 'getTrip',
            getPrice: 'trips/price'
        }),
        generateAIDescription() {
            // 10 modèles de descriptions logistiques prédéfinis
            const templates = [
                "📍 Départ : Centre-ville (Place de la Gare)\n💼 Bagages : Sac à dos ou petite valise acceptés\n💶 Contribution : Partage équitable essence + péages\n🛑 Arrêts : Possibles sur demande\n⏰ Horaire : Flexible (±15 min)",
                "📍 Point de départ : Quartier Nord (Parking Mairie)\n💼 Bagages : 1 valise cabine max par personne\n💶 Frais : Participation aux frais d'essence uniquement\n🛑 Arrêts : Pause possible à mi-chemin\n⏰ Départ : Heure précise",
                "📍 Rendez-vous : Gare routière (sortie principale)\n💼 Bagages : Sac à dos léger de préférence\n💶 Contribution : À discuter selon distance\n🛑 Arrêts : Aucun arrêt prévu (trajet direct)\n⏰ Horaire : Ponctuel",
                "📍 Départ/Arrivée : Centre commercial jusqu'au centre-ville\n💼 Bagages : Petit sac ou cartable accepté\n💶 Frais : Essence + péages partagés équitablement\n🛑 Arrêts intermédiaires : Oui si besoin\n⏰ Flexibilité : ±20 minutes",
                "📍 Zone : Quartier universitaire → Zone industrielle\n💼 Bagages : 1 sac à dos standard max\n💶 Contribution : 50% essence + péages\n🛑 Arrêts : Non, trajet direct rapide\n⏰ Horaire : Très flexible",
                "📍 Point de rencontre : Station-service autoroute A1\n💼 Bagages : Valise moyenne acceptée\n💶 Frais partagés : Essence, péages et parkings\n🛑 Arrêts : Pause café possible\n⏰ Départ : À l'heure convenue",
                "📍 Départ : Place du marché (centre historique)\n💼 Bagages : Sac de voyage ou bagage à main OK\n💶 Participation : Calculée selon km parcourus\n🛑 Pas d'arrêts sauf urgence\n⏰ Horaire : Flexible selon trafic",
                "📍 Rendez-vous : Parking relais métro ligne 2\n💼 Bagages : Petits bagages uniquement (sac à dos)\n💶 Contribution : Essence + péages divisés par nb passagers\n🛑 Arrêts : Si demandé à l'avance\n⏰ Ponctualité requise",
                "📍 Départ/Arrivée : Gare SNCF ↔ Aéroport\n💼 Bagages : 1 valise + 1 bagage cabine max\n💶 Frais : Participation forfaitaire aux frais\n🛑 Trajet direct sans arrêt\n⏰ Départ strict (vol à prendre)",
                "📍 Point de départ : Rond-point des 4 chemins\n💼 Bagages : Sac de sport ou petit sac accepté\n💶 Contribution : Essence proportionnelle à la distance\n🛑 Arrêts possibles si nécessaire\n⏰ Horaire adaptable"
            ];
            
            // Sélection aléatoire d'un modèle
            const randomIndex = Math.floor(Math.random() * templates.length);
            this.trip.description = templates[randomIndex];
            
            // Réinitialiser l'erreur si elle existe
            if (this.commentError) {
                this.commentError.state = false;
            }
            
            console.log('✨ [AI] Description générée:', randomIndex + 1, '/', templates.length);
        },
        generateAIDescriptionForReturn() {
            // 10 modèles de descriptions logistiques prédéfinis (identiques à ceux du trajet aller)
            const templates = [
                "📍 Départ : Centre-ville (Place de la Gare)\n💼 Bagages : Sac à dos ou petite valise acceptés\n💶 Contribution : Partage équitable essence + péages\n🛑 Arrêts : Possibles sur demande\n⏰ Horaire : Flexible (±15 min)",
                "📍 Point de départ : Quartier Nord (Parking Mairie)\n💼 Bagages : 1 valise cabine max par personne\n💶 Frais : Participation aux frais d'essence uniquement\n🛑 Arrêts : Pause possible à mi-chemin\n⏰ Départ : Heure précise",
                "📍 Rendez-vous : Gare routière (sortie principale)\n💼 Bagages : Sac à dos léger de préférence\n💶 Contribution : À discuter selon distance\n🛑 Arrêts : Aucun arrêt prévu (trajet direct)\n⏰ Horaire : Ponctuel",
                "📍 Départ/Arrivée : Centre commercial jusqu'au centre-ville\n💼 Bagages : Petit sac ou cartable accepté\n💶 Frais : Essence + péages partagés équitablement\n🛑 Arrêts intermédiaires : Oui si besoin\n⏰ Flexibilité : ±20 minutes",
                "📍 Zone : Quartier universitaire → Zone industrielle\n💼 Bagages : 1 sac à dos standard max\n💶 Contribution : 50% essence + péages\n🛑 Arrêts : Non, trajet direct rapide\n⏰ Horaire : Très flexible",
                "📍 Point de rencontre : Station-service autoroute A1\n💼 Bagages : Valise moyenne acceptée\n💶 Frais partagés : Essence, péages et parkings\n🛑 Arrêts : Pause café possible\n⏰ Départ : À l'heure convenue",
                "📍 Départ : Place du marché (centre historique)\n💼 Bagages : Sac de voyage ou bagage à main OK\n💶 Participation : Calculée selon km parcourus\n🛑 Pas d'arrêts sauf urgence\n⏰ Horaire : Flexible selon trafic",
                "📍 Rendez-vous : Parking relais métro ligne 2\n💼 Bagages : Petits bagages uniquement (sac à dos)\n💶 Contribution : Essence + péages divisés par nb passagers\n🛑 Arrêts : Si demandé à l'avance\n⏰ Ponctualité requise",
                "📍 Départ/Arrivée : Gare SNCF ↔ Aéroport\n💼 Bagages : 1 valise + 1 bagage cabine max\n💶 Frais : Participation forfaitaire aux frais\n🛑 Trajet direct sans arrêt\n⏰ Départ strict (vol à prendre)",
                "📍 Point de départ : Rond-point des 4 chemins\n💼 Bagages : Sac de sport ou petit sac accepté\n💶 Contribution : Essence proportionnelle à la distance\n🛑 Arrêts possibles si nécessaire\n⏰ Horaire adaptable"
            ];
            
            // Sélection aléatoire d'un modèle
            const randomIndex = Math.floor(Math.random() * templates.length);
            this.otherTrip.trip.description = templates[randomIndex];
            
            // Réinitialiser l'erreur si elle existe
            if (this.otherTrip.commentError) {
                this.otherTrip.commentError.state = false;
            }
            
            console.log('✨ [AI - Return Trip] Description générée:', randomIndex + 1, '/', templates.length);
        },
        setIsPassenger(value) {
            this.$set(this.trip, 'is_passenger', value);
        },
        changeOtherTripDate(date) {
            this.$set(this.otherTrip.dateError, 'state', false);
            this.otherTrip.dateAnswer = date;
        },
        changeDate(date) {
            this.$set(this.dateError, 'state', false);
            this.dateAnswer = date;
        },
        jumpToError() {
            let hasError = document.getElementsByClassName('has-error');
            if (hasError.length) {
                let element = hasError[0];
                this.$scrollToElement(element);
            }
        },
    restoreData(trip) {
        this.no_lucrar = true;
        this.points = [];
        trip.points.forEach((p) => {
            let point = {
                name: p.address,
                json: p.json_address,
                location: {
                    lat: p.lat,
                    lng: p.lng
                },
                place: JSON.stringify(p.json_address),
                error: new Error()
            };
            this.points.push(point);
        });

        // In update mode, add an empty point for adding new intermediary locations
        if (this.updatingTrip && this.points.length >= 2) {
            let newPoint = {
                name: '',
                place: null,
                json: null,
                location: null,
                error: new Error()
            };
            this.points.splice(this.points.length - 1, 0, newPoint);
        }

        // Restore weekly schedule FIRST before date/time
        if (trip.weekly_schedule > 0) {
            this.useWeeklySchedule = true;
            this.weeklySchedule = trip.weekly_schedule;
            console.log('restoreData: set weeklySchedule to', this.weeklySchedule, 'from trip.weekly_schedule', trip.weekly_schedule);

            // Restore weekly schedule time
            if (trip.weekly_schedule_time) {
                this.weeklyScheduleTime = dayjs(trip.weekly_schedule_time).format('HH:mm');
            }
        } else {
            this.useWeeklySchedule = false;

            // Only restore date/time if NOT using weekly schedule
            if (trip.trip_date) {
                this.date = dayjs(trip.trip_date.split(' ')[0]).format('YYYY-MM-DD');
                this.dateAnswer = dayjs(trip.trip_date.split(' ')[0]).format('YYYY-MM-DD');
                this.time = trip.trip_date.split(' ')[1];
            }
        }
        
        this.trip.is_passenger = trip.is_passenger ? 1 : 0;
        this.passengers = trip.passenger_count;
        this.trip.total_seats = trip.total_seats;
        this.trip.friendship_type_id = trip.friendship_type_id;
        this.trip.distance = trip.distance;
        this.trip.description = trip.description;
        
        this.trip.allow_kids = !(trip.allow_kids > 0);
        this.trip.allow_animals = !(trip.allow_animals > 0);
        this.trip.allow_smoking = !(trip.allow_smoking > 0);
        
        if (trip.seat_price_cents != null) {
            this.price = trip.seat_price_cents / 100;
            this.trip.seat_price_cents = trip.seat_price_cents;
        }
        
        this.calcRoute();
    },

        loadTrip() {
            this.getTrip(this.id)
                .then((trip) => {
                    if (this.user.id === trip.user.id) {
                        this.updatingTrip = trip;
                        this.restoreData(trip);
                    } else {
                        this.$router.replace({
                            name: 'trips'
                        });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if (error) {
                        this.$router.replace({
                            name: 'trips'
                        });
                    }
                });
        },

        validate() {
            let globalError = false;
            let validTime = false;
            let validDate = false;
            let validOtherTripTime = false;
            let validOtherTripDate = false;
            let validWeeklySchedule = false;
            this.points = this.points.filter((point) => point.place);
            for (let index = this.points.length; index < 2; index++) {
                this.addPoint(true);
            }
            this.points = this.points.map((point) => {
                delete point.id;
                return point;
            });
            this.points.forEach((p) => {
                if (!p.json) {
                    p.error.state = true;
                    p.error.message = this.$t('localidadValida');
                    globalError = true;
                }
            });

            if (this.showReturnTrip) {
                this.otherTrip.points.forEach((p) => {
                    if (!p.json) {
                        p.error.state = true;
                        p.error.message = this.$t('seleccioneLocalidadValida');
                        globalError = true;
                    }
                });
            }

            if (!this.time || !dayjs(this.time, 'HH mm').isValid()) {
                this.timeError.state = true;
                this.timeError.message = this.$t('noHorarioValido');
                globalError = true;
            } else {
                validTime = true;
            }

            if (
                this.points[0].json &&
                last(this.points).json &&
                this.points[0].name === last(this.points).name
            ) {
                this.points[0].error.state = true;
                this.points[0].error.message = this.$t(
                    'origenDestinoDistintos'
                );
                last(this.points).error.state = true;
                last(this.points).error.message = this.$t(
                    'origenDestinoDistintos'
                );
                this.sameCity = true;
                globalError = true;
            }

            if (this.useWeeklySchedule) {
                // Check if at least one day is selected for weekly schedule
                if (this.weeklySchedule === 0) {
                    globalError = true;
                    this.dateError.state = true;
                    this.dateError.message = this.$t('faltaFechaOProgramaSemanal');
                } else {
                    validWeeklySchedule = true;
                }
                
                // Validate weekly schedule time
                if (!this.weeklyScheduleTime || !dayjs(this.weeklyScheduleTime, 'HH:mm').isValid()) {
                    this.timeError.state = true;
                    this.timeError.message = this.$t('noHorarioValido');
                    globalError = true;
                }
            } else if (
                !(this.dateAnswer && this.dateAnswer.length) ||
                !dayjs(this.dateAnswer).isValid()
            ) {
                globalError = true;
                this.dateError.state = true;
                this.dateError.message = this.$t('faltaFecha');
            } else {
                validDate = true;
            }
            if (this.trip.total_seats < this.passengers) {
                globalError = true;
                this.seatsError.state = true;
                this.seatsError.message =
                    this.$t('yaTienes') +
                    this.trip.passengers +
                    this.$t('pasajerosSubidos');
                dialogs.message(
                    this.$t('yaTienes') +
                        this.trip.passengers +
                        this.$t('pasajerosSubidos'),
                    {
                        estado: 'error'
                    }
                );
            } else if (globalError) {
                dialogs.message(this.$t('algunosDatosNoValidos'), {
                    estado: 'error'
                });
            } else if (
                !this.no_lucrar &&
                this.trip.is_passenger.toString() !== '1'
            ) {
                this.lucrarError.state = true;
                this.lucrarError.message = this.$t('teComprometesANoLucrar');
                dialogs.message(this.$t('teComprometesANoLucrar'), {
                    estado: 'error'
                });
                globalError = true;
            } else if (!this.trip.description) {
                this.commentError.state = true;
                this.commentError.message = this.$t('olvidasteDescripcion');
                dialogs.message(this.$t('olvidasteDescripcion'), {
                    estado: 'error'
                });
            }
            if (validDate && validTime) {
                if (
                    dayjs(this.dateAnswer).format('YYYY-MM-DD') ===
                    dayjs().format('YYYY-MM-DD')
                ) {
                    // la fecha es de hoy, la hora no debería poder ser anterior
                    if (
                        dayjs(this.time, 'HH mm').format('HH mm') <
                        dayjs().format('HH mm')
                    ) {
                        this.timeError.state = true;
                        this.timeError.message = this.$t('viajesPasado');
                        globalError = true;
                    }
                }
            }

            if (this.config.module_max_price_enabled
                && this.trip.is_passenger == 0) {
                if (this.price > this.maximum_seat_price_cents / 100) {
                    globalError = true;
                    this.priceError.state = true;
                    this.priceError.message = this.$t('precioMaximoExcedido');
                } else {
                    this.priceError.state = false;
                }
            }

            if (this.showReturnTrip) {
                if (this.useWeeklySchedule) {
                    // Check if at least one day is selected for weekly schedule
                    if (this.weeklySchedule === 0) {
                        globalError = true;
                        this.otherTrip.dateError.state = true;
                        this.otherTrip.dateError.message = this.$t('faltaFechaOProgramaSemanal');
                    } else {
                        validOtherTripDate = true;
                    }
                    
                    // Validate weekly schedule time
                    if (!this.weeklyScheduleReturnTime || !dayjs(this.weeklyScheduleReturnTime, 'HH:mm').isValid()) {
                        this.otherTrip.timeError.state = true;
                        this.otherTrip.timeError.message = this.$t('noHorarioValido');
                        globalError = true;
                    } else {
                        validOtherTripTime = true;
                    }
                } else {
                    if (
                        !this.otherTrip.time ||
                        !dayjs(this.otherTrip.time, 'HH mm').isValid()
                    ) {
                        this.otherTrip.timeError.state = true;
                        this.otherTrip.timeError.message =
                            this.$t('noHorarioValido');
                        globalError = true;
                    } else {
                        validOtherTripTime = true;
                    }
                }

                if (
                    this.otherTrip.points[0].json &&
                    last(this.otherTrip.points).json &&
                    this.otherTrip.points[0].name ===
                        last(this.otherTrip.points).name
                ) {
                    this.otherTrip.points[0].error.state = true;
                    this.otherTrip.points[0].error.message = this.$t(
                        'origenDestinoDistintos'
                    );
                    last(this.otherTrip.points).error.state = true;
                    last(this.otherTrip.points).error.message = this.$t(
                        'origenDestinoDistintos'
                    );
                    this.otherTrip.sameCity = true;
                    globalError = true;
                }

                if (
                    !(
                        this.otherTrip.dateAnswer &&
                        this.otherTrip.dateAnswer.length
                    ) ||
                    !dayjs(this.otherTrip.dateAnswer).isValid()
                ) {
                    globalError = true;
                    this.otherTrip.dateError.state = true;
                    this.otherTrip.dateError.message = this.$t('faltaFecha');
                } else {
                    validOtherTripDate = true;
                }

                if (validOtherTripTime && validOtherTripDate && !this.useWeeklySchedule) {
                    if (
                        dayjs(this.otherTrip.dateAnswer).format(
                            'YYYY-MM-DD'
                        ) === dayjs().format('YYYY-MM-DD')
                    ) {
                        // la fecha es de hoy, la hora no debería poder ser anterior
                        if (
                            dayjs(this.otherTrip.time, 'HH mm').format(
                                'HH mm'
                            ) < dayjs().format('HH mm')
                        ) {
                            this.otherTrip.timeError.state = true;
                            this.otherTrip.timeError.message =
                                this.$t('viajesPasado');
                            globalError = true;
                        }
                    }

                    let time = dayjs(this.time, 'HH:mm');
                    const tripDate = dayjs(this.dateAnswer)
                        .hour(time.hour())
                        .minute(time.minute())
                        .second(time.second());

                    time = dayjs(this.otherTrip.time, 'HH:mm');
                    const otherTripDate = dayjs(this.otherTrip.dateAnswer)
                        .hour(time.hour())
                        .minute(time.minute())
                        .second(time.second());

                    if (
                        otherTripDate.isBefore(tripDate) ||
                        otherTripDate.isSame(tripDate)
                    ) {
                        this.otherTrip.timeError.state = true;
                        this.otherTrip.timeError.message =
                            this.$t('fechaHoraLogicas');
                        globalError = true;
                    }
                }

                if (!this.otherTrip.trip.description) {
                    this.otherTrip.commentError.state = true;
                    this.otherTrip.commentError.message = this.$t('olvidasteDescripcion');
                    dialogs.message(this.$t('olvidasteDescripcion'), {
                        estado: 'error'
                    });
                }
            }

            return globalError;
        },

        getSaveInfo(tripObj, estimatedTime, useWeeklySchedule = this.useWeeklySchedule, weeklyScheduleTime = this.weeklyScheduleTime) {
            const points = tripObj.points.map((p) => {
                return {
                    address: p.name,
                    json_address: p.json,
                    lat: p.location.lat,
                    lng: p.location.lng
                };
            });

            const tripInfo = {
                points,
                from_town: points[0].address,
                to_town: last(points).address,
                estimated_time: estimatedTime,
                car_id: this.cars.length > 0 ? this.cars[0].id : undefined
            };

            if (!useWeeklySchedule) {
                // Only include trip_date when in specific date view (not using weekly schedule)
                tripInfo.trip_date = tripObj.dateAnswer + ' ' + tripObj.time + ':00';
            } else {
                // Only include weekly_schedule when in weekly schedule view
                tripInfo.weekly_schedule = this.weeklySchedule;
                tripInfo.weekly_schedule_time = weeklyScheduleTime + ':00';
            }

            const result = Object.assign({}, tripObj.trip, tripInfo);
            
            return result;
        },

        save() {
            if (this.validate()) {
                // Jump To Error
                this.$nextTick(() => {
                    this.jumpToError();
                });
                return;
            }
            
            // ===== VÉRIFICATION STRICTE DU TÉLÉPHONE AVANT CRÉATION =====
            // NIVEAU 1 : Vérification frontend pour un feedback immédiat
            const user = this.$store.state.auth.user;
            const config = this.$store.getters['auth/appConfig'];
            
            // Vérifier que la config SMS est activée
            const smsEnabled = config && config.identity_validation_sms_enabled === true;
            const smsRequired = config && config.identity_validation_required_new_users === true;
            
            console.log('🔒 [CREATE TRIP] Vérification du téléphone:');
            console.log('  - SMS enabled:', smsEnabled);
            console.log('  - SMS required:', smsRequired);
            console.log('  - User:', user);
            console.log('  - phone_verified_at:', user ? user.phone_verified_at : 'N/A');
            
            // Vérification stricte : plusieurs niveaux
            if (smsEnabled && smsRequired) {
                // Vérifier que l'utilisateur existe
                if (!user) {
                    console.error('❌ [CREATE TRIP] Utilisateur non connecté');
                    dialogs.message(
                        'Vous devez être connecté pour créer un trajet',
                        { duration: 6, position: 'top-center', estado: 'error' }
                    );
                    return;
                }
                
                // Vérifier que phone_verified_at existe ET n'est pas null/undefined/empty
                const isPhoneVerified = user.phone_verified_at && 
                                       user.phone_verified_at !== null && 
                                       user.phone_verified_at !== undefined && 
                                       user.phone_verified_at !== '' && 
                                       user.phone_verified_at !== 'null';
                
                if (!isPhoneVerified) {
                    console.log('🚫 [CREATE TRIP] Téléphone NON vérifié - Blocage de la création');
                    
                    // Afficher le toast de notification
                    dialogs.message(
                        this.$t('debesVerificarTelefonoParaCrearViaje'),
                        {
                            duration: 6,
                            position: 'top-center',
                            estado: 'error'
                        }
                    );
                    
                    // Rediriger vers l'onglet de vérification du téléphone (onglet 3)
                    setTimeout(() => {
                        this.$router.push({ 
                            name: 'profile', 
                            params: { id: 'me' },
                            hash: '#3' // Onglet: Mes trajets=0, Profil=1, Evaluations=2, Vérification=3
                        });
                    }, 1500);
                    
                    return;
                }
                
                console.log('✅ [CREATE TRIP] Téléphone vérifié - Poursuite de la création');
            }
            
            // ===== POURSUITE DE LA CRÉATION DU TRAJET =====
            
            /* eslint-disable no-unreachable */
            this.saving = true;

            this.trip = this.getSaveInfo(this, this.estimatedTimeString);
            if (!this.updatingTrip) {
                if (this.$redirectToIdentityValidationIfRequired()) {
                    this.saving = false;
                    return;
                }
                let trip = JSON.parse(JSON.stringify(this.trip));
                trip.allow_kids = !(trip.allow_kids > 0);
                trip.allow_animals = !(trip.allow_animals > 0);
                trip.allow_smoking = !(trip.allow_smoking > 0);

                trip.seat_price_cents = this.price * 100;
                
                if (trip.is_passenger === 1) {
                    trip.no_lucrar = 1;
                }
                this.createTrip(trip)
                    .then((t) => {
                        return new Promise((resolve, reject) => {
                            if (!this.showReturnTrip) {
                                return resolve();
                            } else {
                                let otherTrip = this.getSaveInfo(
                                    this.otherTrip,
                                    this.otherTripEstimatedTimeString,
                                    this.useWeeklySchedule,
                                    this.weeklyScheduleReturnTime
                                );
                                otherTrip.parent_trip_id = t.id;
                                otherTrip = JSON.parse(
                                    JSON.stringify(otherTrip)
                                );
                                otherTrip.allow_kids = !otherTrip.allow_kids;
                                otherTrip.allow_animals =
                                    !otherTrip.allow_animals;
                                otherTrip.allow_smoking =
                                    !otherTrip.allow_smoking;
                                otherTrip.seat_price_cents = this.returnPrice * 100;
                                this.createTrip(otherTrip).then((ot) => {
                                    return resolve(ot);
                                });
                            }
                        }).then((ot) => {
                            this.saving = false;
                            
                            // Afficher la notification de succès
                            dialogs.message(this.$t('trajetCreeAvecSucces'), {
                                duration: 5,
                                position: 'top-center',
                                estado: 'success'
                            });
                            
                            this.$router.replace({
                                name: 'detail_trip',
                                params: {
                                    id: t.id
                                }
                            });
                        });
                    })
                    .catch((err) => {
                        console.log('error_creating', err);
                        
                        // NIVEAU 2 : Vérification backend - gérer l'erreur PHONE_NOT_VERIFIED
                        if (err && err.data && err.data.error === 'PHONE_NOT_VERIFIED') {
                            console.log('🚫 [CREATE TRIP - BACKEND] Téléphone non vérifié détecté par le backend');
                            dialogs.message(
                                err.data.message || this.$t('debesVerificarTelefonoParaCrearViaje'),
                                {
                                    duration: 6,
                                    position: 'top-center',
                                    estado: 'error'
                                }
                            );
                            // Rediriger vers l'onglet de vérification
                            setTimeout(() => {
                                this.$router.push({ 
                                    name: 'profile', 
                                    params: { id: 'me' },
                                    hash: '#3'
                                });
                            }, 1500);
                        } else if (this.$checkError(err, 'identity_validation_required')) {
                            this.$router.push({ name: 'identity_validation' });
                            dialogs.message(this.$t('debesValidarIdentidadParaAccion'), {
                                estado: 'error'
                            });
                        } else if (
                            err &&
                            err.data &&
                            err.data.errors &&
                            err.data.errors.driver_is_verified
                        ) {
                            dialogs.message(this.$t('tienesQueSerConductor'), {
                                estado: 'error'
                            });
                        } else {
                            dialogs.message(
                                this.$t('problemaAlCargarElViaje'),
                                {
                                    estado: 'error'
                                }
                            );
                        }
                        this.jumpToError();
                        this.saving = false;
                    });
            } else {
                this.trip.id = this.updatingTrip.id;
                let trip = JSON.parse(JSON.stringify(this.trip));
                trip.allow_kids = !(trip.allow_kids > 0);
                trip.allow_animals = !(trip.allow_animals > 0);
                trip.allow_smoking = !(trip.allow_smoking > 0);
                trip.seat_price_cents = Math.round(this.price * 100);
                this.updateTrip(trip)
                    .then(() => {
                        this.saving = false;
                        this.$router.replace({
                            name: 'detail_trip',
                            params: { id: this.trip.id }
                        });
                    })
                    .catch(() => {
                        this.saving = false;
                    });
            }
        },

        getPlace(i, data, type) {
            type = type || 'trip';

            const trip = type === 'trip' ? this : this.otherTrip;

            trip.points[i].place = data;
            trip.points[i].name = data.name;
            // TODO: Recordar parseStreet
            trip.points[i].json = data;
            trip.points[i].error.state = false;
            trip.center = trip.points[i].location = {
                lat: parseFloat(data.lat),
                lng: parseFloat(data.lng)
            };
            if ((i === 0 || i === trip.points.length - 1) && trip.sameCity) {
                trip.points[0].error.state = false;
                last(trip.points).error.state = false;
            }

            if (type === 'trip') {
                this.addPoint();
                // Mirror the entire points array
                this.otherTrip.points = this.points.slice().reverse().map(point => ({
                    name: point.name,
                    place: point.place,
                    json: point.json,
                    location: point.location,
                    error: new Error(),
                    id: point.id  // Preserve the original ID
                }));
                
                // Update the center to the first point of the return trip
                this.otherTrip.center = this.otherTrip.points[0].location;
                this.calcRoute('returnTrip');
            } else {
                this.addReturnPoint();
            }

            this.calcRoute(type);
            this.recalculateRecommendedPrice();
        },

        getPlaceholder(index) {
            if (this.points.length - 1 === index) {
                return this.$t('destino');
            } else if (index === 0) {
                return this.$t('origen');
            } else {
                return this.$t('ingresePuntoIntermedio');
            }
        },

        onBackButton() {
            this.$router.replace({
                name: 'trips'
            });
        },

        addPoint(force) {
            if (
                this.points.filter((point) => point.name === '').length === 0 ||
                force
            ) {
                let newArr = this.points.splice(0);
                let newp = {
                    name: '',
                    place: null,
                    json: null,
                    location: null,
                    error: new Error(),
                    id: new Date().getTime()
                };
                newArr.splice(this.points.length - 1, 0, newp);
                this.points = newArr;
            }
        },
        addReturnPoint(force) {
            if (
                this.otherTrip.points.filter((point) => point.name === '').length === 0 ||
                force
            ) {
                let newArr = this.otherTrip.points.splice(0);
                let newp = {
                    name: '',
                    place: null,
                    json: null,
                    location: null,
                    error: new Error(),
                    id: new Date().getTime()
                };
                newArr.splice(this.otherTrip.points.length - 1, 0, newp);
                this.otherTrip.points = newArr;
            }
        },
        resetPoints(m, index) {
            if (index === 0 || index === this.points.length - 1) {
                // If removing origin or destination, clear the point
                m.name = '';
                m.place = null;
                m.json = null;
                m.location = null;
            } else {
                // If removing intermediate point, remove it and shift remaining points
                this.points.splice(index, 1);
            }
            // Always recalculate trip info
            this.calcRoute('trip');
        },

        calcRoute(type) {
            type = type || 'trip';

            const trip = type === 'trip' ? this : this.otherTrip;

            let points = trip.points.filter((point) => point.name);

            // Only proceed if we have at least 2 points with names
            if (points.length < 2) {
                return;
            }

            let data = {
                points: points.map((point) => point.location)
            };

            tripApi.getTripInfo(data).then((result) => {
                if (result.status === true) {
                    trip.trip.distance = result.data.distance;
                    trip.duration = result.data.duration;
                    trip.trip.co2 = result.data.co2;
                    trip.route_needs_payment = result.data.route_needs_payment;
                    
                    if (type === 'trip') {
                        this.maximum_trip_price_cents = result.data.maximum_trip_price_cents;
                        this.recommended_trip_price_cents = result.data.recommended_trip_price_cents;
                        this.recalculateRecommendedPrice();
                    } else {
                        this.maximum_return_trip_price_cents = result.data.maximum_trip_price_cents;
                        this.recommended_return_trip_price_cents = result.data.recommended_trip_price_cents;
                        this.recalculateRecommendedReturnPrice();
                    }
                }
            });

            if (this.$refs.map && this.$refs.map.mapObject) {
                let map = this.$refs.map.mapObject;

                /* eslint-disable no-undef */
                L.Routing.control({
                    waypoints: points.map(point => L.latLng(point.location.lat, point.location.lng)),
                    language: appLocaleToRoutingLanguage[this.$i18n.locale] || 'es'
                }).addTo(map);
            }
        },
        validatePrice() {
            if (this.price > this.maximum_seat_price_cents / 100) {
                this.priceError.state = true;
                this.priceError.message = this.$t('precioMaximoExcedido');
            } else {
                this.priceError.state = false;
            }

            if (this.returnPrice > this.maximum_seat_price_cents / 100) {
                this.priceError.state = true;
                this.priceError.message = this.$t('precioMaximoExcedido');
            } else {
                this.priceError.state = false;
            }
        },
        recalculateRecommendedPrice() {
            // The maximum_trip_price_cents is the total price for the entire trip (including driver)
            this.maximum_seat_price_cents = Math.round(this.maximum_trip_price_cents / (this.trip.total_seats + 1));
            this.recommended_seat_price_cents = Math.round(this.recommended_trip_price_cents / (this.trip.total_seats + 1));
            this.validatePrice();
        },
        recalculateRecommendedReturnPrice() {
            this.maximum_return_seat_price_cents = Math.round(this.maximum_return_trip_price_cents / (this.otherTrip.trip.total_seats + 1));
            this.recommended_return_seat_price_cents = Math.round(this.recommended_return_trip_price_cents / (this.otherTrip.trip.total_seats + 1));
            this.validateReturnPrice();
        },
        validateReturnPrice() {
            if (this.returnPrice > this.maximum_return_seat_price_cents / 100) {
                this.returnPriceError.state = true;
                this.returnPriceError.message = this.$t('precioMaximoExcedido');
            } else {
                this.returnPriceError.state = false;
            }
        },
        resetReturnPoints(m, index) {
            if (index === 0 || index === this.otherTrip.points.length - 1) {
                // If removing origin or destination, clear the point
                m.name = '';
                m.place = null;
                m.json = null;
                m.location = null;
            } else {
                // If removing intermediate point, remove it and shift remaining points
                this.otherTrip.points.splice(index, 1);
            }
            // Always recalculate trip info
            this.calcRoute('returnTrip');
        }
    }
};
</script>

<style>
.app-container.new-trip,
.app-container.new-trip main,
.app-container.new-trip #main {
    min-height: 0 !important;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.new-trip .view-container {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
}

.app-container.new-trip .footer-component {
    display: none !important;
}
</style>

<style scoped>
hr {
    border-top: 1px solid var(--primary-color);
    margin: 1em;
}
.no-padding {
    padding: 0;
}
.show-return-trip {
    margin-top: 1em;
}
.preferences-text {
    font-size: 0.8em;
}
.preferences {
    margin-right: 0px;
}
.container {
    padding-top: 0;
}
.trip-type-selection {
    margin-top: 1.4rem;
}
span.error {
    display: block;
    font-size: 12px;
    margin-top: -5px;
    font-weight: bold;
    color: red;
    margin-bottom: 0.4em;
}
span.error.textarea {
    margin-top: 0.8em;
}
.trip_points--left {
    margin-left: 0.5rem;
}
.title--desktop {
    margin-left: 0.5em;
    margin-bottom: 20px;
    color: var(--primary-color);
}
@media only screen and (min-width: 768px) {
    .row-showReturnTrip hr {
        padding-top: 1em;
    }
    hr {
        width: 68%;
    }
    .container {
        padding-top: 1.5em;
    }
    .trip-type-selection {
        margin-top: 0;
    }
    span.error {
        font-weight: 300;
    }
    .row-showReturnTrip {
        margin-bottom: 1.5rem;
    }
}
.tooltip-bottom {
    color: var(--trip-almost-fill-color);
}
textarea.form-control {
    min-height: 14em;
    height: auto;
}
.alert-sellado-viaje {
    margin-top: -1em;
}

.label-tooltip {
    width: 100%;
}

.tooltip-seat-price::before {
    width: 30em;
}

.trip_schedule-toggle {
    margin-bottom: 1em;
}

.schedule-toggle-buttons {
    display: flex;
    gap: 10px;
    margin-bottom: 0.5em;
}

.schedule-toggle-buttons .schedule-tab {
    flex: 1;
    padding: 8px 16px;
    border: 1px solid var(--primary-color);
    background: transparent;
    color: var(--primary-color);
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.schedule-toggle-buttons .schedule-tab:hover {
    background: var(--secondary-background);
    color: white;
}

.schedule-toggle-buttons .schedule-tab.active {
    background: var(--secondary-background);
    color: white;
}

.trip-weekly-schedule {
    margin-bottom: 1em;
}

.trip-create--update {
    margin-top: 2em;
}

.footer-section {
    background: linear-gradient(135deg, #1f3f2e 0%, #2d5016 100%);
    color: #ffffff;
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
    margin-top: 1.5rem;
    margin-bottom: 0 !important;
    padding: 3rem 1rem 0;
}

.footer-container {
    max-width: 1200px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 0.8fr 1.2fr;
    gap: 3rem;
    align-items: start;
}

.footer-left {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.footer-logo-section {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.footer-logo {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.footer-brand-name {
    font-family: 'Poppins', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: #aef7b9;
}

.footer-social-links {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.social-link {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #aef7b9;
    text-decoration: none;
    transition: all 0.3s ease;
}

.social-link:hover {
    background: rgba(174, 247, 185, 0.2);
    color: #ffffff;
    transform: translateY(-3px);
}

.social-link i {
    font-size: 1.25rem;
}

.footer-center {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2.5rem;
}

.footer-column {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.footer-column-title {
    font-family: 'Poppins', sans-serif;
    font-size: 1.1rem;
    font-weight: 600;
    color: #aef7b9;
    margin: 0;
}

.footer-links {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.footer-links li {
    margin: 0;
}

.footer-links a {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.95rem;
    transition: color 0.3s ease;
}

.footer-links a:hover {
    color: #aef7b9;
    text-decoration: underline;
}

.footer-bottom {
    text-align: center;
    margin-top: 2rem;
    margin-bottom: 0;
    padding-top: 2rem;
    padding-bottom: 1.5rem;
    border-top: 1px solid rgba(174, 247, 185, 0.2);
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
}

.footer-copyright {
    font-family: 'Heebo', 'Poppins', sans-serif;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
}

@media (max-width: 1024px) {
    .footer-container {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer-center {
        grid-template-columns: repeat(3, 1fr);
        gap: 2rem;
    }
}

@media (max-width: 768px) {
    .footer-section {
        padding: 2rem 1rem 1rem;
        margin-top: 1rem;
    }

    .footer-left {
        gap: 1.5rem;
    }

    .footer-center {
        grid-template-columns: 1fr;
        gap: 1.5rem;
    }

    .footer-column {
        gap: 0.75rem;
    }

    .footer-column-title {
        font-size: 1rem;
    }

    .footer-links a {
        font-size: 0.9rem;
    }

    .footer-logo {
        width: 40px;
        height: 40px;
    }

    .footer-brand-name {
        font-size: 1.25rem;
    }
}
</style>
